import hosts from '../validators/hosts';

const availableCallbacks = [
  'onThreeDsConfigError',
  'onApplePayAuthorized',
  'onApplePayBillingInfoReceived',
  'onApplePayNotSupported',
  'onApplePayError',
  'onGooglePayAuthorized',
  'onGooglePayError',
  'onGooglePayBillingInfoReceived',
  'onPayPalAuthorized',
  'onPayPalError',
  'onReceivedGoCardlessConfiguration',
  'onCancelGoCardlessModal',
  'onGoCardlessReceiveConfigurationError',
  'onCardTypeDetected',
  'onDirectDebitReceiveConfigurationError',
  'onCancelDirectDebitModal',
  'onReceivedDirectDebitConfiguration',
  'onTreeDsModal',
  'onAddressChange',
  'onPlaidLinkTokenError',
  'onPlaidComplete',
  'onPlaidExit',
  'onPlaidAccountVerificationPending',
  'onPlaidAccountVerificationError',
  'onPlaidAccountVerificationSuccess',
  'onCardDetailsChange',
  'onLoaded',
];

const callbacksWithSkippedDefaultFunction = [
  'onApplePayBillingInfoReceived',
  'onGooglePayBillingInfoReceived',
];

const hasOwnProperty = (obj, propName) =>
  Object.prototype.hasOwnProperty.call(obj, propName);

const onCardDetailsChangeCallbackDefinedAndNotSupported = (userOptions, onCardDetailsChangeCallbackEnabled) => {
  if (!onCardDetailsChangeCallbackEnabled) return false;

  return userOptions.serverHost && hosts.serverHostIsPaymentsService(userOptions.serverHost);
}

const validateCallbacks = (userOptions, callbacks, onCardDetailsChangeCallbackEnabled = false) => {
  const errors = [];

  if (callbacks && typeof callbacks !== 'object') {
    errors.push('second argument of load must be an object');
  }

  if (onCardDetailsChangeCallbackDefinedAndNotSupported(userOptions, onCardDetailsChangeCallbackEnabled)) {
    errors.push('\'onCardDetailsChange\' callback is not supported when using with payments service.');
  }

  availableCallbacks.forEach((callbackName) => {
    if (hasOwnProperty(callbacks, callbackName) && typeof callbacks[callbackName] !== 'function') {
      errors.push(`'${callbackName}' must be a function`);
    } else if (!hasOwnProperty(callbacks, callbackName) && !callbacksWithSkippedDefaultFunction.includes(callbackName)) {
      callbacks[callbackName] = () => {};
    }
  });

  return { result: errors.length === 0, errors: errors };
};

export default {
  validateCallbacks,
};
